// v2 campaign catalog lane — owned by the same agent as app/v2/slot4.tsx. Do not edit
// from another lane. One entry per shipped v2 page.
import type { V2CatalogEntry } from './types';

export const slot4Catalog: V2CatalogEntry[] = [
  {
    rank: 7,
    title: 'Contents Maintenance',
    route: '/inventory/contents2',
    faithfulRoute: '/inventory/contents-maint',
    score: 19,
    blurb:
      'States up front how many of these contents are committed to work and cannot be adjusted — the number PB makes you discover one failed dialog at a time.',
  },
  {
    rank: 18,
    title: 'Global Content Adjustments',
    route: '/rewarehousing/chold2',
    faithfulRoute: '/rewarehousing/chold',
    score: 18,
    blurb:
      'Previews a Group Modify before it fires — "will change N of M tagged, K skipped" plus a before/after sample — instead of finding out on Save.',
  },
  {
    rank: 35,
    title: 'Global Location Assignment',
    route: '/rewarehousing/location-assignment2',
    faithfulRoute: '/rewarehousing/location-assignment',
    score: 17,
    blurb:
      'Compares item velocity against location velocity — the whole reason to run a slotting pass, and the one thing PB never draws.',
  },
  {
    rank: 16,
    title: 'Cycle Count Master',
    route: '/cyc/master2',
    faithfulRoute: '/cyc/master',
    score: 18,
    blurb:
      'Answers "how far along is this count, and what did it lose?" with a progress meter and a lost-inventory tile, and collapses 21 Y/N checkbox columns into the handful of flags that are actually set.',
  },
  {
    rank: 17,
    title: 'Movers (WS + RF)',
    route: '/movers/ws2',
    faithfulRoute: '/movers/ws',
    score: 18,
    blurb:
      'Turns the mover maintenance grid into a live floor board — who is signed in, who is idle, which devices never checked in — with an RF twin at /movers/rf2 that folds the RF screen drills into the same page.',
  },
  {
    rank: 43,
    title: 'Generate Cycle Counts',
    route: '/cyc/generate2',
    faithfulRoute: '/cyc/generate',
    score: 16,
    blurb:
      'Says what a run would actually create before it creates it — locations selected, how many are already counted and untaggable, and the Max Locations cap effect — and leads the 34-toggle options matrix with a diff against Default.',
  },
  {
    rank: 34,
    title: 'Work Search',
    route: '/work/search2',
    faithfulRoute: '/browse/work-search',
    score: 17,
    blurb:
      'Makes the row cap honest — "you are seeing the first 2,000 of an unknown larger set" in words, not a red number — characterises the result set by work type, status, zone and mover, and shows each bulk verb its tag-set preflight and its gate reason before the click.',
  },
  {
    rank: 45,
    title: 'Production Status',
    route: '/inquiry/production-status2',
    faithfulRoute: '/inquiry/production-status',
    score: 16,
    blurb:
      'Answers "is the line fed?" above the six pivots — items staged, pieces staged and a STARVED count of line-feed locations — on a 60s live board, with the area selector promoted to a persistent header scope.',
  },
  {
    rank: 46,
    title: 'Global Velocity Update',
    route: '/rewarehousing/velocity2',
    faithfulRoute: '/rewarehousing/velocity',
    score: 16,
    blurb:
      'Runs the ABC band calculator LIVE — "A: 42 → 55, B: 118 → 104" before anything is written — and reviews Save as a short list of only the rows whose velocity actually changes, with the delta.',
  },
];
